import React from 'react';

// "Skip to previous year" nav glyph (Figma: vertical bar + chevron), 18x18.
// stroke=currentColor is load-bearing: it inherits the parent button's colour
// token across default/hover/disabled states — a hosted-image URL cannot do
// this, which is why it is an Svg component (same pattern as CalendarIcon).
const FirstYearIcon = ({ className }: { className?: string }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M11.25 13.5L6.75 9L11.25 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 4.5V13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default FirstYearIcon;
